<template>
  <q-modal v-model="modalOrder" no-backdrop-dismiss no-esc-dismiss>
    <div>
      <v-header
          :title="$T('order') + ' ' + (form.id || '') + ' - ' + (form['order_status.description'] ?
                    $t(form['order_status.description'].toLowerCase()) : '')"
          icon="find in page">
        <template slot="right">
          <v-button color="faded" class="no-shadow"
                    icon="history" @click.prevent="showLogs = true" small round flat dense>
            <q-tooltip anchor="top left" self="bottom middle">
              {{ $T('communication logs') }}
            </q-tooltip>
          </v-button>
          <v-button flat rounded dense color="primary"
                    icon="close"
                    :label="$T('close')"
                    :disable="form.busy"
                    @click="close"/>
        </template>
      </v-header>
      <card width="100%">

        <form v-if="mockData && user"
              class="row gutter-xs"
              @keydown="form.onKeydown($event)">

          <v-display v-model="form.id"
                     :label="$t('lending number/ID')"
                     :form="form"
                     class="col-xl-3 col-md-4 col-sm-6 col-xs-12">
          </v-display>
          <v-display v-model="form.lead_id"
                     :label="$t('lead number/ID')"
                     :form="form"
                     class="col-xl-3 col-md-4 col-sm-6 col-xs-12">
          </v-display>
          <v-display
              v-model="form.phone"
              :label="$t('cell phone')"
              :form="form"
              class="col-xl-3 col-md-4 col-sm-6 col-xs-12">
          </v-display>

          <v-display v-model="form.nif"
                     :label="$t('NIF')"
                     :form="form"
                     class="col-xl-3 col-md-4 col-sm-6 col-xs-12">
          </v-display>
          <v-display
              v-model="form.email"
              :label="$t('email')"
              :form="form"
              class="col-xl-3 col-md-4 col-sm-6 col-xs-12">
          </v-display>


          <v-display v-model="form['lending_kit.identifier']"
                     :label="$t('lending kit')"
                     :form="form"
                     class="col-xl-3 col-md-4 col-sm-6 col-xs-12">
          </v-display>

          <v-display v-model="startLendingAt"
                     :label="$t('lending start date')"
                     :form="form"
                     class="col-xl-3 col-md-4 col-sm-6 col-xs-12">
          </v-display>

          <v-display v-model="form.days_count"
                     :label="$t('days count')"
                     :form="form"
                     class="col-xl-3 col-md-4 col-sm-6 col-xs-12">
          </v-display>

          <v-display v-model="form.dunning_sms_1"
                     :label="$t('SMS #1')"
                     :form="form"
                     class="col-xl-3 col-md-4 col-sm-6 col-xs-12">
          </v-display>

          <v-display v-model="form.dunning_sms_2"
                     :label="$t('SMS #2')"
                     :form="form"
                     class="col-xl-3 col-md-4 col-sm-6 col-xs-12">
          </v-display>

          <v-display v-model="form.dunning_email_1"
                     :label="$t('Email #1')"
                     :form="form"
                     class="col-xl-3 col-md-4 col-sm-6 col-xs-12">
          </v-display>

          <v-display v-model="form.dunning_email_2"
                     :label="$t('Email #2')"
                     :form="form"
                     class="col-xl-3 col-md-4 col-sm-6 col-xs-12">
          </v-display>

          <v-display path="preferred_time_to_contact"
                     v-model="form.preferred_time_to_contact"
                     :label="$t('preferred time to contact')"
                     :options="mockData.contactTime"
                     :form="form"
                     class="col-xl-3 col-md-4 col-sm-6 col-xs-12"
          > </v-display>


          <br>
          <v-radio-buttons v-if="actions.length > 1"
                           path="action"
                           v-model="action"
                           :label="$T('actions')"
                           :options="actions"
                           :form="form"
                           @input="makeActionDataAdjustments"
                           class="col-12">
          </v-radio-buttons>
          <div class="col-12 row justify-center q-mt-md group">
            <v-button v-if="'Dunning' == form['order_status.description'] &&
                                        ['Reverse Dunning Process'].includes(user.role.name) &&
                                        action == 1"
                      outline
                      :label="$T('dcs sale')"
                      icon="save"
                      color="highlight"
                      class="no-shadow uppercase q-btn-iqos"
                      @click="moveTo('dcs-sale')"
                      :loading="form.busy">
              <template slot="loading">
                <q-spinner-puff class="on-left" color="white"></q-spinner-puff>
                {{ $T('saving...') | capitalize }}
              </template>
            </v-button>

            <v-button v-if="'Dunning' == form['order_status.description'] &&
                                        ['Reverse Dunning Process'].includes(user.role.name) &&
                                        action == 2"
                      outline
                      :label="$T('dsd sale')"
                      icon="save"
                      color="highlight"
                      class="no-shadow uppercase q-btn-iqos"
                      @click="moveTo('dsd-sale')"
                      :loading="form.busy">
              <template slot="loading">
                <q-spinner-puff class="on-left" color="white"></q-spinner-puff>
                {{ $T('saving...') | capitalize }}
              </template>
            </v-button>
          </div>

        </form>

        <div class="justify-center row layout-padding" v-else>
          <spinner-iqos size="60px"/>
        </div>

      </card>
    </div>
    <div>
      <v-header
          :title="$T('Comentários')"
          icon="comment">

      </v-header>
      <card width="100%">

        <form v-if="mockData && user"
              class="row gutter-xs"
              @keydown="form.onKeydown($event)">

          <template>
            <!--<div class="column-4">
              <v-input path="comments"
                       v-model="form.comments"
                       :label="$T('comentário')"
                       optional
                       :form="form"
                       class="col-md-6 col-xs-12">
              </v-input>
            </div>
            <div>
              <v-button
                  :label="$T('gravar')"
                  outline
                  icon="save"
                  color="negative"
                  :loading="form.busy"
                  :form="form"
                  class="no-shadow uppercase q-btn-iqos "
                  @click="saveComment">
              </v-button>
            </div> -->
          </template>
          <div class="px-3 py-3 w-full" style="width: 100%">
            <!--                        <loading-view :loading="loading">-->
            <div class="card relative">
              <div class="overflow-hidden overflow-x-auto relative">

                <table style="width: 100%">
                  <thead>
                  <tr>
                    <th class="w-8" style="text-align: left; width: 33.33%">Comentário</th>
                    <th class="w-8" style="text-align: left; width: 33.33%">Data e Hora</th>
                    <th class="w-8" style="text-align: left; width: 33.33%">Criado por</th>
                  </tr>
                  </thead>
                  <tbody>
                  <tr v-for="row in rows">
                    <td v-bind:class="[ row.user && row.user.id === user.id ? 'w-8 black-comment' : 'w-8 green-comment']">
                      {{ row.comment }}
                    </td>
                    <td v-bind:class="[row.user && row.user.id === user.id ? 'w-8 black-comment' : 'w-8 green-comment']">
                      {{ row.created_at }}
                    </td>
                    <td v-bind:class="[row.user && row.user.id === user.id ? 'w-8 black-comment' : 'w-8 green-comment']">
                      {{ row.user.name }}
                    </td>
                  </tr>
                  </tbody>
                </table>

              </div>
            </div>
            <!--                        </loading-view>-->
          </div>

        </form>

        <div class="justify-center row layout-padding" v-else>
          <spinner-iqos size="60px"/>
        </div>

      </card>
    </div>
    <div>
      <v-header
          :title="$T('calls')"
          icon="phone">

      </v-header>
      <card width="100%">
        <template v-if="mockData && user">
          <form
              class="row gutter-xs"
              @keydown="form.onKeydown($event)">

            <div class="px-3 py-3 w-full" style="width: 100%">
              <!--                        <loading-view :loading="loading">-->
              <div class="card relative">
                <div class="overflow-hidden overflow-x-auto relative">

                  <table style="width: 100%">
                    <thead>
                    <tr>
                      <th class="w-8" style="text-align: left; width: 33.33%">{{ $T('call duration') }}</th>
                      <th class="w-8" style="text-align: left; width: 33.33%">{{ $T('call status') }}</th>
                      <th class="w-8" style="text-align: left; width: 33.33%">{{ $T('call audio') }}</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-for="row in callRows">
                      <td>
                        {{ row.duration }}
                      </td>
                      <td>
                        {{ row.status }}
                      </td>
                      <td>
                        {{ row.recording_url }}
                      </td>
                    </tr>
                    </tbody>
                  </table>

                </div>
              </div>
              <!--                        </loading-view>-->
            </div>

          </form>
        </template>

        <div class="justify-center row layout-padding" v-else>
          <spinner-iqos size="60px"/>
        </div>

      </card>
    </div>
    <order-comm-log v-if="showLogs" :item="item" :show="showLogs" @close="showLogs = false"></order-comm-log>
  </q-modal>
</template>

<script>
import Form from 'vform'
import {mapGetters} from 'vuex'
import moment from 'moment'
import axios from 'axios'
import orderModel from '../../orderModel'
import consumerModel from '../../consumerModel'
import {
  QSpinnerPuff,
  QModal
} from 'quasar-framework'
import changeCase from 'change-case'
import VButton from "../../../components/form/VButton";
import VDisplay from "../../../components/form/VDisplay";
import OrderCommLog from "./OrderCommLog";
// import { Platform } from 'quasar'

export default {
  mixins: [orderModel, consumerModel],

  components: {
    VDisplay,
    VButton,
    QSpinnerPuff,
    QModal,
    OrderCommLog
  },

  props: {
    show: Boolean,
    item: {
      type: Object,
      default: {}
    }
  },

  data () {
    return {
      modalOrder: this.show,
      form: {},
      formConsumer: {},
      mockPath: 'v1/order-detail',
      action: 0,
      stockAction: 0,
      mockData: null,
      genderOptions: [
        {value: 3, label: this.$T("gender male")},
        {value: 4, label: this.$T("gender female")}
      ],
      employeeOptions: [{value: "", label: "-"}],
      comments: null,
      rows: [],
      expire: false,
      canBeCancelled: false,
      canSendNewSms: false,
      canForwardToRemote: false,
      canBeCancelForCourier: false,
      showLogs: false,
      callRows: []
    }
  },

  watch: {
    show (newVal) {
      this.modalOrder = newVal
    },

    item (newItem) {
      this.form = new Form(Object.assign(deepCopy(this.orderModel), newItem))
      this.formConsumer = new Form(Object.assign(deepCopy(this.consumerModel), {
        id: newItem.id,
        phone: newItem.phone,
        firstname: newItem.firstname,
        lastname: newItem.lastname,
        birthdate: newItem.birthdate,
        gender: newItem.gender,
        email: newItem.email,
        zipcode: newItem.zipcode,
        city: newItem.city,
        device: newItem.device,
        referer: newItem.referer,
        observations: newItem.observations,
        contactEmail: newItem.contactEmail,
        last_contact_date: newItem.last_contact_date,
        contact_success_count: newItem.contact_success_count,
        full_employee_name: newItem.full_employee_name
      }));
      this.getMockData();
      this.getComments()
      this.checkCanBeExpired()
      this.checkCanCancel()
      this.canForwardToRemoteCoach()
      this.getCalls()
    }
  },

  methods: {

    async incrementSuccessCount () {

      let response = await this.form.post(`/api/v1/iqos-coach/incrementSuccessCount`);
      if (!response.data) return;

      this.form.contact_success_count = response.data.contact_success_count;
      this.form.last_contact_date = response.data.last_contact_date;
      this.$emit('updated')
      this.close()

    },

    async canForwardToRemoteCoach () {
      if (this.user.role.name === 'Iqos Coach') {
        let {data} = await axios.get(`/api/v1/iqos-coach/canForwardToRemoteCoach/${this.form.id}`);
        if (data.result) {
          this.canForwardToRemote = true;
        }
      }
    },

    async forwardToRemoteCoach () {
      let {data} = await this.form.post(`/api/v1/iqos-coach/forwardToRemoteCoach`);

      if (!data) return;

      this.$q.notify(`${data.errorMessage}`)
      if (data.result)
        this.canForwardToRemote = false;
      this.$emit('updated')
      this.close()
    },

    async saveComment () {
      let {data} = await axios.post(`/api/v1/save-comments`, {
        order_id: this.form.id,
        comment: this.form.comments
      })

      this.form.comments = '';
      this.rows = data;
      this.$emit('updated')
      this.close()
    },

    async getComments () {
      let {data} = await axios.get(`/api/v1/get-ispot-comments/${this.form.id}`);
      this.rows = data;
    },
    async getCalls () {
      let {data} = await axios.get(`/api/v1/get-ispot-calls/${this.form.id}?table=true`);
      this.callRows = data;
    },

    async checkCanBeExpired () {
      let {data} = await axios.get(`/api/v1/call-center/expire/${this.form.id}`);
      if (this.user.role.name === 'Call Center' && data.orderCanBeExpired && parseInt(data.days) === 30) {
        this.expire = true
      }
    },

    async checkCanCancel () {
      if (this.user.role.name === 'Call Center') {
        let {data} = await axios.get(`/api/v1/call-center/waiting-approval/${this.form.id}`);
        this.canBeCancelled = data.orderCanBeCancelled
        this.canSendNewSms = data.canSendNewSms
      }

      if (this.user.role.name === 'Courier') {
        let {data} = await axios.get(`/api/v1/courier/can-be-cancel/${this.form.id}`);
        this.canBeCancelForCourier = data.orderCanBeCancelled
      }
    },

    async getEmployees () {
      let {data} = await axios.get(`${config.appUrl}/api/v1/retail-employees`)
      this.employeeOptions.push(...data)
    },

    close () {
      this.action = 0
      this.stockAction = 0
      this.modalOrder = false
      this.$emit('close')
    },

    async getMockData () {
      this.mockData = null
      const {data} = await axios.get(`${config.appUrl}/api/${this.mockPath}/form-mock-data`)
      this.mockData = data.data
    },

    makeActionDataAdjustments (action) {

      if ([1, 2].includes(action)) {
        this.form.is_sold = true
      }
    },

    async moveTo (orderStatus, stockStatus = '') {

      let isInDunning = this.form['in_dunning']

      if (['Reverse Dunning Process'].includes(this.user.role.name) && isInDunning) {
        this.moveOrderStatus(orderStatus, stockStatus)
      }

    },

    async sendNewSms () {
      this.form.busy = true
      let {data} = await axios.post(`/api/v1/call-center/send-new-sms/${this.form.id}`);
      if (data.result) {
        this.form.busy = false
        this.$q.dialog({
          title: this.$T('success'),
          message: this.$T('Sms enviado com sucesso'),
          preventClose: true,
          color: 'primary',
          stackButtons: true,
          ok: {
            label: `${this.$T("ok")}`
          }
        }).then(() => {
          this.$router.push({name: 'call-center.orders'})
        }).catch(() => {
        })
      }
    },

    async moveToCancelled () {
      this.form.busy = true
      let urlAPI = '';

      if (this.user.role.name === 'Call Center') {
        urlAPI = `/api/v1/call-center/orderCancel/${this.form.id}`;
      } else {
        urlAPI = `/api/v1/courier/orderCancel/${this.form.id}`;
      }

      let {data} = await axios.get(urlAPI);

      if (data.result) {
        this.form.busy = false
        this.$q.dialog({
          title: this.$T('success'),
          message: this.$T('Lending actualizado com sucesso'),
          preventClose: true,
          color: 'primary',
          stackButtons: true,
          ok: {
            label: `${this.$T("ok")}`
          }
        }).then(() => {

          if (this.user.role.name === 'Call Center') {
            this.$router.push({name: 'call-center.orders'})
          } else {
            this.$router.push({name: 'courier.orders'})
          }
        }).catch(() => {
        })
      } else {
        this.form.busy = false
        this.$q.notify(data.message)
      }
    },

    async moveReservedToInLending (orderStatus, stockStatus = '') {

      let greenGo = true

      //Set form to busy
      this.form.busy = true

      // Shorthand
      let role = this.user.role.name

      // Is Call Center closing order?
      let isCallCenterClosing = (orderStatus == 'pending-pick-up' &&
          role == 'Call Center')

      // Is Lending Point closing order?
      let isLendingPointClosing = (orderStatus == 'completed' &&
          (role == 'Lending Point'
              || role == 'Lending Point Indirect'
              || role == 'Lending Point Hostesses'))

      // Is sold?
      let isSold = this.action > 1

      // Is sold with registration?
      let isSoldWithoutRegistration = this.action == 3

      // Adjust classVenda. If is Lending Point and is sold without registration,
      // classVenda must be set to 9. 10 is default value
      if (isLendingPointClosing && isSoldWithoutRegistration)
        this.formConsumer.classVenda = 9

      // Do registration
      if (isSold && !isSoldWithoutRegistration && (isCallCenterClosing || isLendingPointClosing)) {
        this.formConsumer.isSoldWithoutRegistration = isSoldWithoutRegistration
        this.formConsumer.isCallCenterClosing = isCallCenterClosing
        this.formConsumer.isSold = isSold
        await this.formConsumer.post(`${window.config.appUrl}/api/v1/consumer`)
            .then(async ({data}) => {

              while (!this.form.sell_order_number && isCallCenterClosing) {
                await this.$q.dialog({
                  title: this.$T("success"),
                  message: data && data.success.message + (isCallCenterClosing ?
                      ` - ${this.$T('now enter the sell order id:')}` : ''),
                  preventClose: true,
                  prompt: isCallCenterClosing ? {
                    model: ''
                  } : null,
                  color: "primary",
                  ok: {
                    label: this.$T("ok")
                  }
                }).then(orderNumber => {
                  this.form.sell_order_number = orderNumber
                })
              }
            })
            .catch(async ({response}) => {
              greenGo = false
              await this.$q.dialog({
                title: this.$T("error"),
                message: response && response.data.message,
                preventClose: true,
                color: "negative",
                ok: {
                  label: this.$T("ok")
                }
              })
              this.form.busy = false
            })
      }

      if (greenGo) {
        // Get the given email and phone back to the main form
        this.form.email = this.formConsumer.email
        this.form.phone = this.formConsumer.phone
        // Now we may need other fields as well
        this.form.birthdate = this.formConsumer.birthdate
        this.form.device = this.formConsumer.device
        this.form.referer = this.formConsumer.referer
        this.form.zipcode = this.form.zipcode || this.formConsumer.zipcode
        this.form.isSoldWithoutRegistration = isSoldWithoutRegistration
        this.form.isSold = isSold
        this.form.contactEmail = this.form.contactEmail || this.formConsumer.contactEmail

        await this.form.post(
            `${this.baseUrl}/order/${this.form.id}/move-to/${orderStatus}/${stockStatus}`)
            .then(({data}) => {
              this.close()
              this.$emit('updated')
              let msg = data.success.message

              if (data.apiResult && data.apiResult.deviceAlreadyRegisteredOrNotValid) {
                msg += `\nRetalho: ${data.apiResult.message}`;
              }

              this.$q.dialog({
                title: this.$T('success'),
                message: msg,
                preventClose: true,
                color: 'primary',
                stackButtons: true,
                ok: {
                  label: this.$T('close')
                }
              })
            }).catch(({response}) => {
              let message = "";
              if (response && response.data.hasOwnProperty('errors')) {
                Object.values(response.data.errors).forEach((item) => {
                  message += item + ", \n"

                })
              } else {
                message = "erro de comunicação. Tente novamente mais tarde"
              }

              this.$q.dialog({
                title: response.data.message,
                message: message,
                preventClose: true,
                color: "negative",
                ok: {
                  label: this.$T("ok")
                }
              })

              this.form.busy = false
            })

      }

    },

    moveOrderStatus (orderStatus, stockStatus = '') {
      this.form.busy = true
      this.$q.dialog({
        title: this.$_t('this action will update the order status to :order_status',
            {order_status: this.$t(orderStatus)}),
        preventClose: true,
        color: 'primary',
        cancel: true,
      }).onOk(() => {
        axios.post(`/api/v1/order/${this.form.id}/move-to/${orderStatus}/${stockStatus}`)
      })

      this.form.busy = false
      this.$emit('close')
    },

    moveKitAndCloseOrder (stockStatus) {
      this.form.busy = true
      this.$q.dialog({
        title: this.$_t('this action will close the order and update kit to :stock_status',
            {stock_status: this.$t(stockStatus)}),
        preventClose: true,
        color: 'primary',
        cancel: true,
      }).then(async () => {
        axios.post('/api/v1/move-kit-close-order', {
          order_id: this.form.id,
          stock_status: stockStatus
        })
            .then((response) => {
              if (response.data.hasOwnProperty('success')) {
                this.$q.notify({
                  color: 'positive',
                  icon: 'thumb_up',
                  message: response.data.success.message
                })
              }
            })
      }).catch(() => {

      })
      this.form.busy = false
      this.$emit('close')
    }

  },

  computed: {
    ...mapGetters({
      user: 'auth/user'
    }),

    baseUrl () {
      return `${window.config.appUrl}/api/v1/${changeCase.paramCase(this.user.role.name)}`
    },

    startLendingAt () {
      if (!this.form.start_lending_at)
        return this.$T('not started yet')
      return moment(this.form.start_lending_at).format('DD-MM-YYYY')
    },

    birthdate () {
      if (!this.form.birthdate)
        return this.$T('not started yet')
      return moment(this.form.birthdate).format('DD-MM-YYYY')
    },

    endLendingAt () {
      if (!this.form.end_lending_at && !this.form.start_lending_at)
        return this.$_T(':days days after start', {days: this.mockData.lendingDays})
      else if (this.form.start_lending_at && !this.form.end_lending_at)
        return moment(this.form.start_lending_at).add(this.mockData.lendingDays, 'days')
            .format('DD-MM-YYYY') + ' - ' + this.$T('planned')
      return moment(this.form.end_lending_at).format('DD-MM-YYYY')
    },

    formatedAddress () {
      if (this.form.address)
        return this.form.address + ', ' +
            (this.form.address_2 ? this.form.address_2 + ', ' : '') +
            this.form.city + '. ' +
            this.$T('zip code') + ': ' + this.form.zipcode
      return ''
    },

    formatedPickupAddress () {
      if (this.form.pickup_address)
        return this.form.pickup_address + ', ' +
            (this.form.pickup_address_2 ? this.form.pickup_address_2 + ', ' : '') +
            this.form.pickup_city + '. ' +
            this.$T('zip code') + ': ' + this.form.pickup_zipcode
      return ''
    },

    actions () {
      let order = this.item
      let role = this.user.role.name
      let orderStatus = this.form['order_status.description']
      let lendingPointType = this.form['lending_point.lending_point_type_id']

      let actions = [{value: 0, label: this.$T('no action')}]


      if (role == 'Reverse Dunning Process' && orderStatus == 'Dunning') {
        actions = actions.concat([
          {value: 1, label: `${this.$T('dunning')} <strong>&gt; ${this.$T('dcs sale')}</strong>`},
          {value: 2, label: `${this.$T('dunning')} <strong>&gt; ${this.$T('dsd sale')}</strong>`}
        ])
      }

      return actions
    },

    stockActions () {
      let role = this.user.role.name
      let orderStatus = this.form['order_status.description']

      let actions = [{value: 0, label: this.$T('no action')}]

      if ((orderStatus == 'Pending Pickup' && role == 'Courier') ||
          (orderStatus == 'In Lending' && (role == 'Lending Point' || role == 'Lending Point Indirect' || role == 'Lending Point Hostesses')))
        actions = [
          {
            value: 0,
            stockStatus: 'to-clean',
            label: `${this.$T('lending kit')} <strong>&gt; ${this.$T('to clean/charge')}</strong>`
          },
          {
            value: 11,
            stockStatus: 'broken',
            label: `${this.$T('lending kit')} <strong>&gt; ${this.$T('broken')}</strong>`
          },
          {
            value: 12,
            stockStatus: 'lost',
            label: `${this.$T('lending kit')} <strong>&gt; ${this.$T('lost')}</strong>`
          },
          {
            value: 13,
            stockStatus: 'not-returned',
            label: `${this.$T('lending kit')} <strong>&gt; ${this.$T('not returned')}</strong>`
          }
        ]

      return actions
    },

    canRegisterConsumer () {
      return this.action == 2 && ['Call Center', 'Lending Point', 'Lending Point Indirect', 'Lending Point Hostesses', 'Iqos Coach'].includes(this.user.role.name)
    },

    canRegisterDevice () {
      return this.action == 2 && ['Lending Point', 'Lending Point Indirect', 'Lending Point Hostesses', 'Iqos Coach'].includes(this.user.role.name)
    },

    alreadySentToDCS () {
      return !!this.form.iqos_user_id
    },

    canSelectEmployee () {
      return this.action == 2 && ['Lending Point', 'Lending Point Indirect', 'Lending Point Hostesses'].includes(this.user.role.name)
    },

    maxBirthDate () {
      return moment().subtract(18, 'years').format('YYYY-MM-DD\THH:mm:ss.SSSZ')
    },

    canUserCompleteNotReturned () {
      //@waiting for client (PMI) instructions for conditions to enable the action
      return false
    }
  },
  mounted () {
    this.getEmployees();
  },

  created: function () {

    window.addEventListener('updateDeviceEvent', (data) => {
      this.formConsumer.device = data.detail.value;
    })
  },

  destroyed: function () {
    window.removeEventListener('updateDeviceEvent', () => {
    })
  }
}
</script>

<style>
.codentify-camera-img {
  width: 4em;
  display: block;
  margin-top: 0.5em;
}

.column-4 {
  float: left;
  width: 90%;
  padding: 10px;
}

.green-comment {
  color: #229954 !important;
}

.black-comment {
  color: black !important;
}
</style>



// WEBPACK FOOTER //
// resources/assets/js/pages/backoffice/order/orderDunningDetail.vue